import React, { useEffect, useState } from 'react'

import ResultHistoryContainer from './ResultHistoryContainer'
import loadingImg from '../../assets/dong-loading/dong-loading.png'

import './ResultHistory.scss'

function Home() {
  //const [posts, setPosts] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true)
    }
    return () => {}
  }, [isLoaded])

  return (
    <div className='home page'>
      <div className='news container mx-auto'>
        {isLoaded ? (
          <ResultHistoryContainer />
        ) : (
          <div className='loader loading-gif'>
            <img className='loading-indicator-gif ' src={loadingImg} alt='loading' />
          </div>
        )}
      </div>
    </div>
  )
}

export default Home
